import { dashboardPathFor } from '@/components/shell/navModel'

/**
 * Where a person lands right after signing in (Login, Signup's automatic sign-in, Reset's "Save and
 * sign in"): root goes to the admin console, everyone else to their role's dashboard. The role →
 * dashboard rules come from the nav model, so the sidebar's Today entry, the router's "/" redirect
 * and this can't drift apart. The router guard adds `?org=<slug>` after the redirect.
 */
export function postLoginPath(role: string | undefined): string {
  if (role === 'root') return '/admin'
  return dashboardPathFor(role)
}
